import React, { useMemo } from 'react'
import cs from 'classnames'

import './style.sass'

interface LoadingProps {
	variant?: 'rect' | 'circle' | 'text'
	className?: string
	width?: string
	height?: string
}

export default function Loading({ variant = 'rect', className, width = '', height = '' }: LoadingProps) {
	const cx = cs('LoadingContainer', className, {
		'LoadingContainer--rect': variant === 'rect',
		'LoadingContainer--circle': variant === 'circle',
		'LoadingContainer--text': variant === 'text',
	})
	const style = useMemo(() => ({ width, height }), [width, height])
	return <div style={style} className={cx}></div>
}
